class WishlistHero extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const params = new URLSearchParams(window.location.search)
    const name = params.get('name')

    if (name) {
      this.els.title.element.innerText = name
    }
  }
}

if (!customElements.get('wishlist-hero')) {
  customElements.define('wishlist-hero', WishlistHero)
}
